module.exports = __webpack_public_path__ + "static/assets/fe4932a46e7da7116f8d13302a26a92e.gif";